import { render, staticRenderFns } from "./DashboardItemsConfigList.vue?vue&type=template&id=1deca2d5"
import script from "./DashboardItemsConfigList.vue?vue&type=script&lang=js"
export * from "./DashboardItemsConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports